<template>
  <div class="empty">
    <img class="noimg" src="../../../assets/imgs/notips.png" />
  </div>
</template>

<script>
export default {
  name: 'empty'
}
</script>

<style lang="less" scoped>
.empty {
  .noimg {
    display: block;
    width: 100%;
  }
}
</style>
